<template>
  <div class="rt-select">
    <van-field v-model="result" v-bind="$attrs" readonly is-link @click="show = !show" />
    <van-popup v-model="show" position="bottom">
      <van-picker
        :columns="columns"
        show-toolbar
        :title="$attrs.label"
        :default-index="activeIndex"
        value-key="categoryName"
        @cancel="show = !show"
        @confirm="onConfirm"
        :item-height="$vanItemHeight"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  model: {
    prop: "selectValue"
  },
  props: {
    columns: {
      type: Array
    },
    selectValue: {
      type: String
    },
    defaultIndex: {
      type: Number
    }
  },
  data() {
    return {
      show: false,
      result: this.selectValue,
      activeIndex: this.defaultIndex
    };
  },
  methods: {
    onConfirm(value) {
      this.result = value.categoryName;
      this.show = !this.show;
    }
  },
  watch: {
    selectValue: function(newVal) {
      // this.result = newVal;
    },
    result(newVal) {
      const columns = [...this.columns];
      columns.forEach(item => {
        if (newVal == item.categoryName) {
          this.$emit("input", item.activtyId + "");
        }
      });
    },
    activeIndex() {
      this.activeIndex = this.defaultIndex;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
